const PAYMENT_METHODS = [
  {
    label: 'Credit Card',
    type: 'paymentMethods',
    count: 0,
    checked: false,
    value: 'cc',
  },
  {
    label: 'Amex',
    type: 'paymentMethods',
    count: 0,
    checked: false,
    value: 'mx',
  },
  {
    label: 'Hicaps',
    type: 'paymentMethods',
    count: 0,
    checked: false,
    value: 'hc',
  },
  {
    label: 'PayPal',
    type: 'paymentMethods',
    count: 0,
    checked: false,
    value: 'pp',
  },
  {
    label: 'Seniors Discounts',
    type: 'paymentMethods',
    count: 0,
    checked: false,
    value: 'sd',
  },
  {
    label: 'Bulk Billing',
    type: 'paymentMethods',
    count: 0,
    checked: false,
    value: 'bb',
  },
  {
    label: 'Bitcoin',
    type: 'paymentMethods',
    count: 0,
    checked: false,
    value: 'bcn',
  },
];

const PAY_LATER = [
  {
    label: 'OpenPay',
    type: 'payLater',
    count: 0,
    checked: false,
    value: 'op',
  },
  {
    label: 'Zip Pay',
    type: 'payLater',
    count: 0,
    checked: false,
    value: 'zp',
  },
  {
    label: 'AfterPay',
    type: 'payLater',
    count: 0,
    checked: false,
    value: 'ap',
  },
  {
    label: 'Humm',
    type: 'payLater',
    count: 0,
    checked: false,
    value: 'hmm',
  },
  {
    label: 'Interest Free',
    type: 'payLater',
    count: 0,
    checked: false,
    value: 'itf',
  },
];

const OPENING_HOURS = [
  {
    label: 'Open Now',
    type: 'openingHours',
    count: 0,
    checked: false,
    value: 'on',
  },
  {
    label: 'Open Late',
    type: 'openingHours',
    count: 0,
    checked: false,
    value: 'ol',
  },
  {
    label: 'Open 24/7',
    type: 'openingHours',
    count: 0,
    checked: false,
    value: 'tfs',
  },
];

const PRICE_RANGE = [
  {
    label: '$',
    type: 'priceRange',
    count: 0,
    checked: false,
    value: 'cp',
  },
  {
    label: '$$',
    type: 'priceRange',
    count: 0,
    checked: false,
    value: 'af',
  },
  {
    label: '$$$',
    type: 'priceRange',
    count: 0,
    checked: false,
    value: 'exp',
  },
  {
    label: '$$$+',
    type: 'priceRange',
    count: 0,
    checked: false,
    value: 'pm',
  },
];

export { PAYMENT_METHODS, PAY_LATER, OPENING_HOURS, PRICE_RANGE };
